import Button from '@rezdy/components/Button';
import Layout from './Layout';
import Message from './Message';
import React from 'react';
import routes from '../constants/routes';
import routing from '../services/routing';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface ISignedIn extends WithTranslation {
    username: string;
}

class SignedIn extends React.PureComponent<ISignedIn> {
    onClickChangeEmail = () => {
        routing.push(routes.CHANGE_EMAIL);
    };

    onClickChangeProfile = () => {
        routing.push(routes.PROFILE);
    };

    onClickSignOut = () => {
        routing.push(routes.SIGN_OUT);
    };

    onClick = () => {
        routing.push(routes.SIGN_IN);
    };

    render() {
        const { username, i18n } = this.props;
        return (
            <Layout>
                <Message>{i18n.t('signedIn.message', { username: username })}</Message>
                <Button action="secondary" width="100%" onClick={this.onClickChangeProfile}>
                    {i18n.t('secondaryAction', { context: 'changeProfile' })}
                </Button>
                <Button action="secondary" reversed width="100%" onClick={this.onClickSignOut}>
                    {i18n.t('secondaryAction', { context: 'signOut' })}
                </Button>
            </Layout>
        );
    }
}

export default withTranslation()(SignedIn);
